import { bootstrapApplication } from '@angular/platform-browser';
import { HttpErrorResponse } from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Errores del navegador a Sentry (tarea 259). Sin sentryDsn no manda nada.
if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.sentryEnvironment,
    // Los errores de la API ya los registra el backend: acá sólo los del navegador.
    beforeSend: (event, hint) =>
      hint.originalException instanceof HttpErrorResponse ? null : event,
  });

  const host = window.location.hostname;
  const sufijo = '.' + environment.centralHost;
  if (host.endsWith(sufijo)) {
    Sentry.setTag('negocio', host.slice(0, -sufijo.length));
  }
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
